import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css'; // Import your CSS file if you have one

const talk = () => {
  return (
    <div className="home-container">
      <header className="home-header">
        <h1>Talk Archive</h1>
        <p>Select a page to visit:</p>
      </header>
      <main className="home-content">
        <nav className="home-nav">
          <ul>
            <li>
              <Link to="/viewtalkarchive">View Talk Archive</Link>
            </li>
            <li>
              <Link to="/Create2">Create Talk Archive</Link>
            </li>
            <li>
            <Link to="/talk">EM CONSTRUÇÃO</Link>
            </li>
            <li>
              <Link to="/home">Home</Link>
            </li>
            <li>
              <Link to="/">Log-out</Link>
            </li>
          </ul>
        </nav>
      </main>
    </div>
  );
}

export default talk;
